// extracted by mini-css-extract-plugin
export var cardLayout = "_9n-1";
export var paginationContainer = "_9n-0";